import Cookies from 'js-cookie';
import { getUserRegionCode } from '../utils/geoip-detect';
import { parseDomain } from "parse-domain";

function getBannersToShow() {
  let cookieBanners = [
    ...document.querySelectorAll('.c-banner-marketing[data-cookie]'),
  ];

  cookieBanners = cookieBanners.filter((banner) => {
    let willShow = false;

    if (!Cookies.get(banner.getAttribute('data-cookie'))) {
      const visibleOn = banner.getAttribute('data-visible-on');

      if (typeof visibleOn === 'string' && visibleOn.length > 0) {
        // Geo-IP specific logic.
        const visibleStates = visibleOn.toUpperCase().split(',');

        getUserRegionCode((regionCode) => {
          banner.setAttribute('data-user-region', regionCode);

          if (visibleStates.includes(regionCode)) {
            willShow = true;
          }
        });
      } else {
        willShow = true;
      }
    }
    return willShow;
  });

  return cookieBanners;
}

function bannerCookie() {
  const bannersToOpen = getBannersToShow();

  bannersToOpen.forEach((banner) => banner.classList.remove('u-none'));
}

/**
 * Returns whether there will be banners to open on the page or not
 * @returns boolean
 */
export function bannerWillOpen() {
  const cookieBanners = getBannersToShow();

  return Boolean(cookieBanners.length);
}

function buttonSweep() {
  document
    .querySelector('.c-banner-marketing--close button')
    .addEventListener('click', (event) => {
      const eventTarget = event.target;

      eventTarget.closest('.c-banner-marketing').classList.add('slide-down');

      Cookies.set(
        eventTarget.closest('.c-banner-marketing').getAttribute('data-cookie'),
        'true',
      );
    });
}

function setPrevUrl() {
  const { hostname } = new URL(window.location.href);
  const parsed = parseDomain(hostname);

  Cookies.set('previousUrl', window.location.href, { domain: `${parsed.domain}.${parsed.topLevelDomains?.join('.')}`});
}

function bannerNavigationListener() {
  document
    .querySelector('.c-banner-marketing a[data-button]')
    .addEventListener('click', () => {
      setPrevUrl();
    });
}

export function init() {
  if (document.querySelector('.c-banner-marketing')) {
    buttonSweep();
    bannerNavigationListener();
    bannerCookie();
  }
}
